@use '../zr-theme/zr-variables.scss' as *;

$component: 'zr-add-to-cart-overlay';

:host {
    --vx-atcc-background-color: var(--vx-add-to-cart-count__color, #00859B);
}

div[slot="zr-modal-trigger"] {
    display: flex;
    align-items: center;

    .zr-add-to-cart-overlay__quantity {
        flex: 1;
        height: 44px;
        padding-right: 8px;
        color: var(--ci-primary400);
        font-weight: 600;
    }
}

.#{$component}__add {
    background-color: var(--vx-atcc-background-color);
    transition: background-color 0.3s ease;
    right: 0;
    user-select: none;
    height: 44px;
    width: 44px;
    border: none;
    border-radius: var(--vx-add-to-cart-count__border-radius, 8px);
    cursor: pointer;

    &:focus {
        outline: 3px solid var(--ci-primary600);
        outline-offset: -1px;
    }

    &:hover {
        background-color: var(--vx-atcc-background-hover-color, #006B7E);
    }

    &:active {
        background-color: var(--vx-atcc-background-hover-color, #00505E);
    }

    &:disabled {
        cursor: default;
        background-color: var(--ci-neutral500);
    }
}

.zr-modal-loading {
    position: relative;
    height: calc(100vh - 90px);

    @media only screen and (min-width: $tablet-screen) {
        height: 200px;
    }
}

zr-modal.large {
    --zr-modal-width: 600px;
}
